import { Filter, PaginatedResponse } from '@libs/models/common';
import { filterToQueryParams } from '../utils/filterToQueryParams';
import { LinesOfBusinessFetchItem } from './types';
import { LinesOfBusiness } from './mocks';

type fetchAgenciesListParams = {
  search?: string;
  page?: number;
  size?: number;
  filters?: Filter[];
};
export async function fetchLinesOfBusinessList(
  params?: fetchAgenciesListParams,
): Promise<PaginatedResponse<LinesOfBusinessFetchItem[]>> {
  const filters = filterToQueryParams((params?.filters ?? []).map((fil) => ({ field: fil.key, value: fil.value })));

  // const response = await request.get<PaginatedResponse<LinesOfBusinessFetchItem[]>>('/facilities', {
  //   params: {
  //     pageNumber: params?.page || 1,
  //     pageSize: params?.size || 50,
  //     search: params?.search || undefined,
  //     ...filters,
  //   },
  // });

  const fake = async () =>
    new Promise<PaginatedResponse<LinesOfBusinessFetchItem[]>>((resolve) => {
      setTimeout(() => {
        resolve({
          // ...response.data,
          hasNextPage: false,
          hasPreviousPage: false,
          pageNumber: 1,
          pageSize: LinesOfBusiness.length,
          totalCount: LinesOfBusiness.length,
          items: LinesOfBusiness,
        });
      }, 1000);
    });

  return await fake();
}
